/**
 * Escala canónica de z-index del sistema v2.
 *
 * Orden estricto (de mayor a menor):
 *
 *   12000 — TOAST            Notificaciones flotantes (XP, alertas no bloqueantes)
 *   11500 — TOOLTIP          Tooltips/popovers de hover porteados a body (deben flotar sobre su trigger, incl. dentro de modales)
 *   11000 — MODAL            Contenido de modales (rsuite/v2)
 *   10990 — MODAL_BACKDROP   Backdrop del modal (justo debajo del contenido)
 *   10800 — DRAWER           Drawers laterales y side-panes
 *   10790 — DRAWER_BACKDROP  Backdrop del drawer
 *    6000 — NAVBAR           Sidebar, top-navbar, navegación persistente
 *    5600 — QUICKIE_PANEL    Panel flotante de evaluaciones rápidas (Quickie)
 *    5500 — FIXED_CIRCLE     Botones circulares flotantes (LiquidFixedCircleButton)
 *    5000 — EXPLORE_REACTION Efectos efímeros en feed (emoji gigante, partículas)
 *    3000 — DROPDOWN         Dropdowns, tooltips, popovers, LiquidPillDropdown (abierto)
 *  "auto" — BASE             Contenido normal, LiquidPill cerrado, badges, chips
 *
 * Reglas:
 *
 * 1. **Modales** siempre arriba de todo lo que no sea toast.
 * 2. **Navbar** siempre debajo de modales pero sobre dropdowns y contenido.
 * 3. **Dropdowns/tooltips** sobre contenido pero debajo de navbar.
 * 4. **LiquidPill en estado normal** NO debe tener z-index alterado.
 *    Solo se eleva al nivel DROPDOWN cuando es `LiquidPillDropdown` abierto.
 * 5. Cualquier elemento nuevo debe importar de este archivo, nunca un número mágico.
 */
export const Z_INDEX = {
  TOAST:           12000,
  TOOLTIP:         11500,
  MODAL:           11000,
  MODAL_BACKDROP:  10990,
  DRAWER:          10800,
  DRAWER_BACKDROP: 10790,
  NAVBAR:           6000,
  QUICKIE_PANEL:    5600,
  FIXED_CIRCLE:     5500,
  EXPLORE_REACTION: 5000,
  DROPDOWN:         3000,
  /** Valor para resetear: `style={{ zIndex: Z_INDEX.BASE }}` no aplica nada. */
  BASE:            "auto" as const,
} as const;

export type ZIndexKey = keyof typeof Z_INDEX;
